import React, {Component} from 'react';
import {connect} from 'react-redux';
import config from "./../../config";
import common from './../../common';
import OutsideNotifier from '../../OutsideNotifier';
import {
    getSubscribeInfo,
    postUpdateTeamName,
    postDeleteFantasyTeam,
} from './../../actions/SettingActions';
import GeneralPopUp from './../GeneralPopUp';
import apiError from './../../constants/api-error';
import {postSubscribe,} from './../../actions/HomeActions';
import AdBottom from '../AdBottom';

class UserSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showGeneralPopup : false,
            showEditNamePopup: false,
            isSubscribe      : false,
            isChkDisabled    : false,
            teamName         : '',
            oldTeamName      : '',
        };
    }

    componentDidMount() {
        const tName = common.getTeamName();
        this.setState({
            teamName   : tName,
            oldTeamName: tName,
        });
        this.props.getSubscribeInfo().then(() => {
            const {IsNewsLetter} = this.props.subscribeInfo;
            let isChecked = +IsNewsLetter === 1;
            this.setState({isSubscribe: isChecked});
        });
    }

    resetToast = () => {
        common.removeBodyScroll();
        this.setState({showGeneralPopup: false, message: ''});
    };
    closeSettingsPopup = () => {
        common.removeBodyScroll();
        this.setState({showEditNamePopup: false, message: '', teamNameError: ''});
    };
    editButtonClick = (e) => {
        e.stopPropagation();
        common.addBodyScroll();
        this.setState({
            teamName         : this.state.oldTeamName,
            showEditNamePopup: true,
        });
    };
    updateTeamName = () => {
        common.showLoader();
        const OBJ = {};
        OBJ.OptType = 1;
        OBJ.TeamName = this.state.teamName;
        this.props.postUpdateTeamName(OBJ)
            .then(() => {
                const {response} = this.props.updateTeamNameData;
                const retVal = response.Meta['RetVal'];
                const messageTrans = apiError.updateTeamName[retVal];
                const message = this.props.trans[messageTrans];
                common.hideLoader();
                if (response.Meta['Success'] && retVal === 1) {
                    this.closeSettingsPopup();
                    this.setState({
                        oldTeamName     : this.state.teamName,
                        showGeneralPopup: true,
                        isToast         : true,
                        message         : message,
                        wrapperClasses  : 'si-warning-toast si-success-popup',
                        iconClass       : 'icon-ucl-tick',
                        resetToast      : this.resetToast
                    });
                } else {
                    this.setState({
                        showEditNamePopup: true,
                        teamNameError    : message,
                    });
                }
            });
    };
    updateNewsletterSubscriptionStatus = (e) => {
        e.stopPropagation();
        const isChecked = e.target.checked;
        this.setState({isSubscribe: isChecked, isChkDisabled: true});
        const subscribePromise = this.props.postSubscribe(isChecked);
        subscribePromise.then((objSubscribe) => {
            let retVal = objSubscribe && objSubscribe.payload && objSubscribe.payload.Meta && objSubscribe.payload.Meta.RetVal;
            if (retVal === 1) {
                this.setState({isSubscribe: isChecked, isChkDisabled: false});
            }
            else {
                this.setState({isChkDisabled: false});
                // let sMessage = (trans.somethingWentWrong);
                // self.showOrHideTostMessages(true, sMessage);
            }
        }).catch(reason => {
            this.setState({isChkDisabled: false});
        });
    };
    deleteFantasyTeam = (e) => {
        e.stopPropagation();
        e.stopPropagation();
        const OBJ = {};
        OBJ.OptType = 1;
        this.props.postDeleteFantasyTeam(OBJ)
            .then(() => {
                const {response} = this.props.deleteFantasyTeamData;
                const retVal = response.Meta['RetVal'];
                const messageTrans = apiError.updateTeamName[retVal];
                const message = this.props.trans[messageTrans];
                if (response.Meta['Success'] && retVal === 1) {
                } else {
                }
            });
    };
    isDisabled = () => {
        const value = this.state.teamName;
        return (value.length === 0) || (value.trim().length > config.MAX_TEAM_NAME_LENGTH) || (value.trim().length < config.MIN_TEAM_NAME_LENGTH) || (value === this.state.oldTeamName);
    };
    onTeamNameChange = (e) => {
        const teamName = e.target.value;
        const val = common.validateInput(teamName);
        this.setState({teamName: val});
    };

    render() {
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-manage-team'   : true,
            'si-no-anim'       : true,
            'si-leagues'       : true
        });
        const {trans} = this.props;
        const {showGeneralPopup, showEditNamePopup, teamNameError, isToast, message, wrapperClasses, iconClass, resetToast, teamName, oldTeamName} = this.state;
        const {IsNewsLetter, IsTeamNameEditable} = this.props.subscribeInfo;
        const userCanEditTeamName = +IsTeamNameEditable===1;
        const isChkChecked = this.state.isSubscribe;
        const switchClasses = common.makeClasses({
            'si-switch'  : true,
            'si-disabled': this.state.isChkDisabled,
        });
        const chkClasses = common.makeClasses({
            'si-custom-chkbox': true,
            'si-disabled'     : this.state.isChkDisabled,
        });
        const modalClass = common.makeClasses({
            'si-modal-wrap': true,
        });
        const wrapperClassesInPopup = common.makeClasses({
            'si-common-popup'  : true,
            'si-settings-popup': true,
        });
        const saveButtonClasses = common.makeClasses({
            'si-btn'        : true,
            'si-btn-primary': true,
            'si-disabled'   : this.isDisabled(),
        });
        const title = trans.enter_team_name;
        const inputTitle = trans.teamName;
        const inputPlaceHolder = trans.enter_team_name;
        const primaryBtnText = trans.save;
        const popupProps = {};
        popupProps.showPopup = showGeneralPopup;
        popupProps.isToast = isToast;
        popupProps.message = message;
        popupProps.wrapperClass = wrapperClasses;
        popupProps.iconClass = iconClass;
        popupProps.resetToast = resetToast;
        return <div className={wrapperClass}>
            <div className="si-container si-settings-pg">
                <div className="si-top-section">
                    <div className="si-leagues-header si-flexBox">
                        <div className="si-back-btn si-cols">
                            <i className="icon-ucl-back_arrow"/>
                        </div>
                        <div className="si-cols si-header-txt">
                            <span>{trans.settings}</span>
                        </div>
                        <div className="si-common-menu">
                        </div>
                        {userCanEditTeamName ? <div className="si-btn si-btn-secondary" onClick={(e) => this.editButtonClick(e)}>
                            <span>{trans.edit}</span>
                        </div> : null}
                    </div>
                </div>
                <div className="si-leagues-container">
                    <div className="si-lg-settings">
                        <div className="si-edit-wrp">
                            <div className="si-grp-name">
                                <div className="si-title">{trans.teamName}</div>
                                <span className="si-team">{oldTeamName}</span>
                            </div>
                            {userCanEditTeamName ? <div className="si-edit-btn" onClick={(e) => this.editButtonClick(e)}>
                                <span>{trans.edit}</span>
                            </div> : null}
                        </div>
                        {/* <div className="si-nwsletter">
                            <div className={chkClasses} onChange={(e) => this.updateNewsletterSubscriptionStatus(e)}>
                                <input type="checkbox" checked={isChkChecked} />
                                <div className="si-check-mark"></div>
                            </div>
                            <span className="si-subs-txt">{trans.subscribeToNewsletter}</span>
                            <label className={switchClasses} onChange={(e) => this.updateNewsletterSubscriptionStatus(e)}>
                                <input type="checkbox" className="si-chkbox" checked={isChkChecked} />
                                <span className="si-slider"></span>
                            </label>
                        </div> */}
                        <div className="si-league-name">
                            <div className="si-error-msg">
                                <span>{trans.team_name_exist}</span>
                            </div>
                            <div className="si-loader-wrap si-flexBox si-display-none">
                                <div className="si-loader"/>
                            </div>
                        </div>
                        {/* <div className="si-btn si-no-border-btn si-disabled" onClick={(e) => this.deleteFantasyTeam(e)}>
                            <span>{trans.deleteFantasyTeam}</span>
                        </div> */}
                    </div>
                </div>
                <AdBottom />
                {showEditNamePopup ? <div className={modalClass}>
                    <OutsideNotifier handler={this.closeSettingsPopup.bind(this)}>
                        <div className={wrapperClassesInPopup}>
                            <div className="si-popup-body si-flexBox">
                                <i className="si-close icon-ucl-close" onClick={() => this.closeSettingsPopup()}/>
                                <div className="si-details-wrap">
                                    <div className="si-title">{title}</div>
                                    <div className="si-league-name">
                                        <div className="si-title">{inputTitle}</div>
                                        <div className="si-input-wrap">
                                            <input type="text" name="" value={teamName} placeholder={inputPlaceHolder}
                                                   maxLength={config.MAX_TEAM_NAME_LENGTH}
                                                   onChange={(e) => this.onTeamNameChange(e)}/>
                                        </div>
                                        {teamNameError ? <div className="si-error-msg" style={{display: 'block'}}>
                                            <span>{teamNameError}</span>
                                        </div> : null}
                                        <div className="si-loader-wrap si-flexBox si-display-none">
                                            <div className="si-loader"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="si-popup-btn-wrap">
                                <div className={saveButtonClasses} onClick={() => this.updateTeamName()}>
                                    <span>{primaryBtnText}</span>
                                </div>
                            </div>
                        </div>
                    </OutsideNotifier>
                </div> : null}
                <GeneralPopUp {...popupProps} />
            </div>
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getSubscribeInfo     : () => dispatch(getSubscribeInfo()),
        postSubscribe        : (isSubscribe) => dispatch(postSubscribe(isSubscribe)),
        postUpdateTeamName   : (obj) => dispatch(postUpdateTeamName(obj)),
        postDeleteFantasyTeam: (obj) => dispatch(postDeleteFantasyTeam(obj)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans                : state.appData.trans,
        subscribeInfo        : state.formationData.subscribeInfo,
        objSubscribe         : state.homeData.objSubscribe,
        updateTeamNameData   : state.formationData.updateTeamNameData,
        deleteFantasyTeamData: state.formationData.deleteFantasyTeamData,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(UserSettings));


// WEBPACK FOOTER //
// ./src/components/user-settings/index.js